<section class="users-view">
  <!-- Media object starts -->
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="media d-flex align-items-center">
        <a href="javascript:;">
          <img
            [src]="imageUrl + userData?.image"
            alt="user view
                        avatar"
            class="users-avatar-shadow rounded"
            height="64"
            width="64"
          />
        </a>
        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{ userData?.name }}</span>
            <!-- <span class="text-muted font-medium-1">
                  <span>@</span>
                  <span class="users-view-username">dean3004</span>
                </span> -->
          </h4>
          <span class="mr-1">ID:</span>
          <span class="users-view-id">{{
            userData?._id.substring(userData?._id.length - 6)
          }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 col-sm-5 d-flex justify-content-end
            align-items-center">
            <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary
                mr-2
                px-3 py-1"><i class="ft-mail"></i></a>
            <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary
                mr-2
                px-3 py-1">Profile</a>
            <a [routerLink]="['/users-edit',userData?._id]" class="btn btn-sm
                btn-primary px-3 py-1">Edit</a>
        </div> -->
  </div>
  <!-- Media object ends -->

  <div class="row">
    <div class="col-12">
      <!-- Card data starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-xl-4">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>Registered:</td>
                      <td>{{ userData?.createdOn | date: "shortDate" }}</td>
                    </tr>
                    <tr>
                      <td>Latest Activity:</td>
                      <td class="users-view-latest-activity">
                        {{ userData?.updatedOn | date: "shortDate" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Verified:</td>
                      <td class="users-view-verified">Yes</td>
                    </tr>
                    <!-- <tr>
                                            <td>Role:</td>
                                            <td class="users-view-role">{{userData?.role?.type
                                                |
                                                titlecase }}</td>
                                        </tr> -->
                    <!-- <tr>
                                            <td>Status:</td>
                                            <td><span class="badge
                                                    bg-light-success
                                                    users-view-status">{{userData?.status}}</span></td>
                                        </tr> -->
                  </tbody>
                </table>
              </div>
              <!-- <div class="col-12 col-xl-8 users-module">
                    <div class="table-responsive">
                      <table class="table mb-0">
                        <thead>
                          <tr>
                            <th>Module Permission</th>
                            <th>Read</th>
                            <th>Write</th>
                            <th>Create</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Users</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <td>Articles</td>
                            <td>No</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>Yes</td>
                          </tr>
                          <tr>
                            <td>Staff</td>
                            <td>Yes</td>
                            <td>Yes</td>
                            <td>No</td>
                            <td>No</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- Card data ends -->
    </div>
    <div class="col-12">
      <!-- User detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- <div class="row bg-primary bg-lighten-4 rounded mb-3 mx-1 text-center text-lg-left">
                  <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                    <h6 class="primary align-self-center mb-0 mx-1">Posts:</h6>
                    <span class="font-large-1 primary">125</span>
                  </div>
                  <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                    <h6 class="primary align-self-center mb-0 mx-1">Followers:</h6>
                    <span class="font-large-1 primary">534</span>
                  </div>
                  <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                    <h6 class="primary align-self-center mb-0 mx-1">Following:</h6>
                    <span class="font-large-1 primary">256</span>
                  </div>
                </div> -->
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>College:</td>
                      <td class="users-view-username">
                        {{ userData?.college }}
                      </td>
                    </tr>
                    <tr>
                      <td>Course:</td>
                      <td class="users-view-username">
                        {{ userData?.course?.courseName }}
                      </td>
                    </tr>
                    <tr>
                      <td>Qualification:</td>
                      <td class="users-view-username">
                        {{ userData?.lastQualification }}
                      </td>
                    </tr>
                    <!-- <tr>
                          <td>Name:</td>
                          <td class="users-view-name">Dean Stanley</td>
                        </tr> -->
                    <!-- <tr>
                                            <td>E-mail:</td>
                                            <td>{{userData?.email}}</td>
                                        </tr> -->
                    <!-- <tr>
                          <td>Company:</td>
                          <td>XYZ Corp. Ltd.</td>
                        </tr> -->
                  </tbody>
                </table>
              </div>

              <!-- <h5 class="mb-2 text-bold-500"><i class="ft-link mr-2"></i>Social Links</h5>
                  <div class="table-responsive">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Twitter:</td>
                          <td><a href="javascript:;">https://www.twitter.com/</a></td>
                        </tr>
                        <tr>
                          <td>Facebook:</td>
                          <td><a href="javascript:;">https://www.facebook.com/</a></td>
                        </tr>
                        <tr>
                          <td>Instagram:</td>
                          <td><a href="javascript:;">https://www.instagram.com/</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Personal Info
              </h5>
              <div class="table-responsive">
                <table class="table table-borderless m-0">
                  <tbody>
                    <!-- <tr>
                                            <td>Birthday:</td>
                                            <td>{{userData?.DOB |
                                                date:'shortDate'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Address:</td>
                                            <td>{{userData?.address}}</td>
                                        </tr> -->
                    <!-- <tr>
                          <td>Languages:</td>
                          <td>English</td>
                        </tr> -->
                    <tr>
                      <td>Name:</td>
                      <td class="users-view-username">{{ userData?.name }}</td>
                    </tr>
                    <tr>
                      <td>E-mail:</td>
                      <td>{{ userData?.email }}</td>
                    </tr>
                    <tr>
                      <td>Contact:</td>
                      <td>{{ userData?.phoneNumber }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- User detail ends -->
    </div>
  </div>
</section>
